/**
 * @generated SignedSource<<46419614aa0a9cd7fb3ab0020b22f88f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventInviteCodeFragment$data = {
  readonly invite: {
    readonly code: string | null | undefined;
    readonly id: string;
    readonly viewerCanManage: boolean;
  };
  readonly " $fragmentType": "EventInviteCodeFragment";
};
export type EventInviteCodeFragment$key = {
  readonly " $data"?: EventInviteCodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventInviteCodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventInviteCodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventPublicInvite",
      "kind": "LinkedField",
      "name": "invite",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": "viewerCanManage",
          "args": [
            {
              "kind": "Literal",
              "name": "action",
              "value": "MANAGE_EVENT_INVITE_CODE"
            }
          ],
          "kind": "ScalarField",
          "name": "viewerCan",
          "storageKey": "viewerCan(action:\"MANAGE_EVENT_INVITE_CODE\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "5195deba01198d565f68dad083250415";

export default node;
